import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from '../hooks/useRefreshToken';
import useAuth from '../hooks/useAuth';
import useLocalStorage from "../hooks/useLocalStorage";
import { Container,Spinner } from "react-bootstrap";

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth } = useAuth();
    const [persist] = useLocalStorage('persist', true);

    useEffect(() => {
        let isMounted = true;

        const verifyRefreshToken = async () => {
            try {
                await refresh();
            }
            catch (err) {
                console.error(err);
            }
            finally {
                isMounted && setIsLoading(false);
            }
        }

        // persist added here AFTER tutorial video
        // Avoids unwanted call to verifyRefreshToken
        !auth?.accessToken && persist ? verifyRefreshToken() : setIsLoading(false);

        return () => isMounted = false;
    }, [])

    return (
        <>
            {!persist
                ? <Outlet />
                : isLoading
                    ? <Container className="text-center d-flex flex-column align-items-center my-5">
                    <Spinner animation="border" role="status" style={{ width: "8rem", height: "8rem" }}>
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                  <p className="text-center my-3 fw-bold fs-3 text-success">Cargando datos</p>
                  </Container>
                    : <Outlet />
            }
        </>
    )
}

export default PersistLogin